import { useContext, useMemo } from 'react';
import { LoginContext } from "../components/EditorCommon/LoginContext";


/**
 * Creates a new instance of the WebApiClient with the correct context
 * @param clientConstructor
 */
export function useClient<T>(clientConstructor: { new (baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }): T }): T {


    const loginContext = useContext(LoginContext);
    return useMemo(() =>
        new clientConstructor(undefined, loginContext.loginService.http),
        [loginContext.loginService.http, clientConstructor]
        );
}
